<template>
  <v-app>
    <TheAppBar />
    <TheAppNavigationDrawer />
    <v-main>
      <RouterView v-slot="{ Component }">
        <!-- keep-alive only for the chat page -->
        <KeepAlive :include="['ChatPage']">
          <component :is="Component" />
        </KeepAlive>
      </RouterView>
    </v-main>
    <AppLocale />
    <DeepReloadPrompt v-if="!isLocal()" content-class="top-0" />
    <Toaster
      position="top-right"
      :duration="2000"
      rich-colors
      close-button
      close-button-position="top-right"
      :toast-options="{
        style: {
          fontSize: '14px',
        },
      }"
    />
    <FilePreviewDialog :ref="setPreviewDialogRef" :fullscreen="xs" />
  </v-app>
</template>
<script setup lang="ts">
import { Toaster } from 'vue-sonner'
import { useDisplay } from 'vuetify'
import { DeepReloadPrompt } from '@deepcloud/deep-ui-lib'
import TheAppBar from '@/components/TheAppBar.vue'
import AppLocale from './components/AppLocale'
import FilePreviewDialog from './components/preview/FilePreviewDialog.vue'
import TheAppNavigationDrawer from './components/TheAppNavigationDrawer.vue'
import 'vue-sonner/style.css'
import { isLocal } from '@/utils/env'
import { useDocumentTitle } from './composables/use-document-title'
import { provideFilePreview } from './composables/use-file-preview.ts'

const { xs } = useDisplay()
const { setPreviewDialogRef } = provideFilePreview()
useDocumentTitle()
</script>
